export interface IndividuoArboreo {
  id: string;
  codigoCta: string;
  tipo: string;
  especie: string;
  nomeCientifico: string;
  nomePopular: string;
  projeto: string;
  municipio: string;
  uf: string;
  bairro: string;
  logradouro: string;
  numero: string;
  coordenada: string;
  dap: number;
  altura: number;
  diametroCopa: number;
  estadoFitossanitario: string;
  classeRisco: string;
  recomendacao: string;
  statusRevisao: string;
  tecnico: string;
  ultimaVistoria: string;
  fotos: number;
  observacao: string;
  fotoUrl: string;
}

export const tiposIndividuo = [
  "Árvore",
  "Palmeira",
  "Muda",
  "Arbusto de porte arbóreo",
  "Toco",
  "Indivíduo morto",
  "Não identificado",
];

export const statusRevisaoList = [
  "cadastrada",
  "em revisão",
  "validada",
  "pendente de informação",
  "não localizada",
  "arquivada",
];

export const estadosFitossanitarios = ["bom", "regular", "ruim", "critico", "morto"];

export const classesRisco = ["baixo", "medio", "alto", "critico"];

export const recomendacoesManejo = [
  "Sem intervenção",
  "Monitorar",
  "Poda de limpeza",
  "Poda corretiva",
  "Poda emergencial",
  "Tratamento fitossanitário",
  "Supressão",
  "Transplante",
  "Replantio",
  "Vistoria complementar",
];

export const estadoFitoConfig: Record<string, { badge: string; label: string }> = {
  bom: { badge: "bg-primary-100 text-primary-700", label: "Bom" },
  regular: { badge: "bg-warning-100 text-warning-700", label: "Regular" },
  ruim: { badge: "bg-danger-100 text-danger-700", label: "Ruim" },
  critico: { badge: "bg-danger-50 text-danger-600 border border-danger-300", label: "Crítico" },
  morto: { badge: "bg-background-100 text-foreground-500", label: "Morto" },
};

export const riscoConfig: Record<string, { badge: string; label: string }> = {
  baixo: { badge: "bg-primary-100 text-primary-700", label: "Baixo" },
  medio: { badge: "bg-caution-100 text-caution-700", label: "Médio" },
  alto: { badge: "bg-warning-100 text-warning-700", label: "Alto" },
  critico: { badge: "bg-danger-100 text-danger-700", label: "Crítico" },
};

export const statusRevisaoConfig: Record<string, { badge: string; label: string }> = {
  cadastrada: { badge: "bg-secondary-100 text-secondary-700", label: "Cadastrada" },
  "em revisão": { badge: "bg-warning-100 text-warning-700", label: "Em Revisão" },
  validada: { badge: "bg-primary-100 text-primary-700", label: "Validada" },
  "pendente de informação": { badge: "bg-caution-100 text-caution-700", label: "Pendente" },
  "não localizada": { badge: "bg-danger-100 text-danger-700", label: "Não Localizada" },
  arquivada: { badge: "bg-background-100 text-foreground-500", label: "Arquivada" },
};

export const resumoCta = {
  totalIndividuos: 12486,
  validadas: 10932,
  pendentesRevisao: 642,
  riscoCritico: 87,
  podaRecomendada: 516,
  supressaoRecomendada: 34,
  especiesIdentificadas: 186,
  fotosAnexadas: 38420,
};

export const qualidadeCta = {
  coordenadaValida: 94.2,
  comFoto: 87.5,
  especieIdentificada: 96.8,
  vistoriaValidada: 91.3,
  responsavelTecnico: 99.1,
};

export const individuos: IndividuoArboreo[] = [
  {
    id: "ARV-001",
    codigoCta: "CTA-GO-5208707-000001",
    tipo: "Árvore",
    especie: "Handroanthus chrysotrichus",
    nomeCientifico: "Handroanthus chrysotrichus (Mart. ex DC.) Mattos",
    nomePopular: "Ipê-amarelo",
    projeto: "Implantação do CTA — Goiânia Centro",
    municipio: "Goiânia",
    uf: "GO",
    bairro: "Setor Central",
    logradouro: "Av. Goiás",
    numero: "1530",
    coordenada: "-16.6789, -49.2645",
    dap: 45,
    altura: 12.5,
    diametroCopa: 8.2,
    estadoFitossanitario: "bom",
    classeRisco: "baixo",
    recomendacao: "Monitorar",
    statusRevisao: "validada",
    tecnico: "Carlos Mendes",
    ultimaVistoria: "2026-06-25",
    fotos: 4,
    observacao: "Indivíduo adulto, floração intensa em agosto. Copa bem formada, sem sinais de podridão.",
    fotoUrl: "",
  },
  {
    id: "ARV-002",
    codigoCta: "CTA-GO-5208707-000002",
    tipo: "Árvore",
    especie: "Caesalpinia pluviosa",
    nomeCientifico: "Caesalpinia pluviosa DC.",
    nomePopular: "Sibipiruna",
    projeto: "Implantação do CTA — Goiânia Centro",
    municipio: "Goiânia",
    uf: "GO",
    bairro: "Setor Marista",
    logradouro: "Rua 1135",
    numero: "420",
    coordenada: "-16.6890, -49.2720",
    dap: 52,
    altura: 14.0,
    diametroCopa: 10.5,
    estadoFitossanitario: "regular",
    classeRisco: "medio",
    recomendacao: "Poda de limpeza",
    statusRevisao: "validada",
    tecnico: "Ana Oliveira",
    ultimaVistoria: "2026-06-18",
    fotos: 3,
    observacao: "Galhos secos na porção inferior da copa. Presença de liquens. Recomendada poda de limpeza.",
    fotoUrl: "",
  },
  {
    id: "ARV-003",
    codigoCta: "CTA-GO-5208707-000003",
    tipo: "Árvore",
    especie: "Licania tomentosa",
    nomeCientifico: "Licania tomentosa (Benth.) Fritsch",
    nomePopular: "Oiti",
    projeto: "Inventário de Praça — Praça Universitária",
    municipio: "Goiânia",
    uf: "GO",
    bairro: "Setor Universitário",
    logradouro: "Praça Universitária",
    numero: "s/n",
    coordenada: "-16.6812, -49.2567",
    dap: 38,
    altura: 9.8,
    diametroCopa: 7.5,
    estadoFitossanitario: "bom",
    classeRisco: "baixo",
    recomendacao: "Sem intervenção",
    statusRevisao: "validada",
    tecnico: "Rafael Torres",
    ultimaVistoria: "2026-06-20",
    fotos: 5,
    observacao: "Indivíduo saudável, boa estrutura. Frutos presentes na época de vistoria.",
    fotoUrl: "",
  },
  {
    id: "ARV-004",
    codigoCta: "CTA-GO-5208707-000004",
    tipo: "Árvore",
    especie: "Mangifera indica",
    nomeCientifico: "Mangifera indica L.",
    nomePopular: "Mangueira",
    projeto: "Inventário de Parque — Parque Municipal Ambiental Norte",
    municipio: "Goiânia",
    uf: "GO",
    bairro: "Setor Norte",
    logradouro: "Parque Municipal Ambiental Norte",
    numero: "s/n",
    coordenada: "-16.6520, -49.2890",
    dap: 78,
    altura: 18.2,
    diametroCopa: 15.0,
    estadoFitossanitario: "regular",
    classeRisco: "alto",
    recomendacao: "Poda corretiva",
    statusRevisao: "em revisão",
    tecnico: "Juliana Costa",
    ultimaVistoria: "2026-06-15",
    fotos: 6,
    observacao: "Indivíduo centenário. Copa assimétrica com galhos pesados sobre área de estar. Raízes expostas em raio de 5m.",
    fotoUrl: "",
  },
  {
    id: "ARV-005",
    codigoCta: "CTA-GO-5208707-000005",
    tipo: "Palmeira",
    especie: "Roystonea oleracea",
    nomeCientifico: "Roystonea oleracea (Jacq.) O.F.Cook",
    nomePopular: "Palmeira-imperial",
    projeto: "Implantação do CTA — Goiânia Centro",
    municipio: "Goiânia",
    uf: "GO",
    bairro: "Setor Central",
    logradouro: "Av. Anhanguera",
    numero: "3200",
    coordenada: "-16.6750, -49.2610",
    dap: 35,
    altura: 22.0,
    diametroCopa: 4.5,
    estadoFitossanitario: "bom",
    classeRisco: "baixo",
    recomendacao: "Monitorar",
    statusRevisao: "validada",
    tecnico: "Carlos Mendes",
    ultimaVistoria: "2026-06-28",
    fotos: 3,
    observacao: "Palmeira adulta, estipe reto. Folhas basais secas necessitam remoção preventiva.",
    fotoUrl: "",
  },
  {
    id: "ARV-006",
    codigoCta: "CTA-GO-5208707-000006",
    tipo: "Árvore",
    especie: "Delonix regia",
    nomeCientifico: "Delonix regia (Bojer ex Hook.) Raf.",
    nomePopular: "Flamboyant",
    projeto: "Loteamento Verde Vale",
    municipio: "Goiânia",
    uf: "GO",
    bairro: "Jardim Verde",
    logradouro: "Rua das Acácias",
    numero: "88",
    coordenada: "-16.7010, -49.3120",
    dap: 28,
    altura: 8.5,
    diametroCopa: 6.8,
    estadoFitossanitario: "ruim",
    classeRisco: "critico",
    recomendacao: "Supressão",
    statusRevisao: "em revisão",
    tecnico: "Ana Oliveira",
    ultimaVistoria: "2026-06-10",
    fotos: 7,
    observacao: "Inclinado 25° em direção à via. Cavidade extensa no tronco com presença de cupins. Risco de queda. Laudo em andamento.",
    fotoUrl: "",
  },
  {
    id: "ARV-007",
    codigoCta: "CTA-GO-5208707-000007",
    tipo: "Árvore",
    especie: "Jacaranda mimosifolia",
    nomeCientifico: "Jacaranda mimosifolia D.Don",
    nomePopular: "Jacarandá-mimoso",
    projeto: "Implantação do CTA — Goiânia Centro",
    municipio: "Goiânia",
    uf: "GO",
    bairro: "Jardim Goiás",
    logradouro: "Alameda das Rosas",
    numero: "650",
    coordenada: "-16.6950, -49.2780",
    dap: 32,
    altura: 10.2,
    diametroCopa: 7.0,
    estadoFitossanitario: "bom",
    classeRisco: "baixo",
    recomendacao: "Sem intervenção",
    statusRevisao: "validada",
    tecnico: "Pedro Alves",
    ultimaVistoria: "2026-06-22",
    fotos: 4,
    observacao: "Indivíduo jovem, floração abundante em setembro. Desenvolvimento vigoroso.",
    fotoUrl: "",
  },
  {
    id: "ARV-008",
    codigoCta: "CTA-GO-5208707-000008",
    tipo: "Árvore",
    especie: "Paubrasilia echinata",
    nomeCientifico: "Paubrasilia echinata (Lam.) Gagnon, H.C.Lima & G.P.Lewis",
    nomePopular: "Pau-brasil",
    projeto: "Inventário de UC — Parque Natural Municipal",
    municipio: "Goiânia",
    uf: "GO",
    bairro: "Setor Leste",
    logradouro: "Parque Natural Municipal",
    numero: "s/n",
    coordenada: "-16.6880, -49.2450",
    dap: 22,
    altura: 7.0,
    diametroCopa: 4.2,
    estadoFitossanitario: "bom",
    classeRisco: "baixo",
    recomendacao: "Monitorar",
    statusRevisao: "validada",
    tecnico: "Fernanda Lima",
    ultimaVistoria: "2026-06-15",
    fotos: 5,
    observacao: "Indivíduo jovem em UC. Plantado em programa de reintrodução. Acompanhamento trimestral.",
    fotoUrl: "",
  },
  {
    id: "ARV-009",
    codigoCta: "CTA-GO-5208707-000009",
    tipo: "Árvore",
    especie: "Ficus benjamina",
    nomeCientifico: "Ficus benjamina L.",
    nomePopular: "Ficus",
    projeto: "Monitoramento de Árvores Críticas — Setor Bueno",
    municipio: "Goiânia",
    uf: "GO",
    bairro: "Setor Bueno",
    logradouro: "Rua T-55",
    numero: "1200",
    coordenada: "-16.7040, -49.2820",
    dap: 92,
    altura: 20.5,
    diametroCopa: 18.0,
    estadoFitossanitario: "ruim",
    classeRisco: "critico",
    recomendacao: "Poda emergencial",
    statusRevisao: "em revisão",
    tecnico: "Pedro Alves",
    ultimaVistoria: "2026-06-12",
    fotos: 9,
    observacao: "Sistema radicular comprometendo calçada e rede de esgoto. Galhos com rachaduras. Relatório emergencial emitido. Vistoria trimestral obrigatória.",
    fotoUrl: "",
  },
  {
    id: "ARV-010",
    codigoCta: "CTA-GO-5208707-000010",
    tipo: "Árvore",
    especie: "Tibouchina granulosa",
    nomeCientifico: "Tibouchina granulosa (Desr.) Cogn.",
    nomePopular: "Quaresmeira",
    projeto: "Compensação Ambiental — Corredor Verde Sul",
    municipio: "Goiânia",
    uf: "GO",
    bairro: "Corredor Verde Sul",
    logradouro: "Av. Corredor Verde",
    numero: "s/n",
    coordenada: "-16.7200, -49.2950",
    dap: 18,
    altura: 5.5,
    diametroCopa: 3.8,
    estadoFitossanitario: "bom",
    classeRisco: "baixo",
    recomendacao: "Sem intervenção",
    statusRevisao: "validada",
    tecnico: "Marcos Vinicius",
    ultimaVistoria: "2026-06-05",
    fotos: 3,
    observacao: "Indivíduo jovem de plantio recente (2 anos). Boa adaptação. Floração roxa intensa em março.",
    fotoUrl: "",
  },
  {
    id: "ARV-011",
    codigoCta: "CTA-GO-5208707-000011",
    tipo: "Árvore",
    especie: "Hymenaea courbaril",
    nomeCientifico: "Hymenaea courbaril L.",
    nomePopular: "Jatobá",
    projeto: "Projeto Carbono Urbano — Áreas Verdes Municipais",
    municipio: "Goiânia",
    uf: "GO",
    bairro: "Setor Sul",
    logradouro: "Praça Cívica",
    numero: "s/n",
    coordenada: "-16.6795, -49.2578",
    dap: 65,
    altura: 16.8,
    diametroCopa: 12.5,
    estadoFitossanitario: "regular",
    classeRisco: "medio",
    recomendacao: "Tratamento fitossanitário",
    statusRevisao: "validada",
    tecnico: "Gabriel Santos",
    ultimaVistoria: "2026-06-08",
    fotos: 5,
    observacao: "Indivíduo adulto, importante para sequestro de carbono. Presença de cochonilhas na casca. Tratamento recomendado.",
    fotoUrl: "",
  },
  {
    id: "ARV-012",
    codigoCta: "CTA-GO-5208707-000012",
    tipo: "Muda",
    especie: "Myracrodruon urundeuva",
    nomeCientifico: "Myracrodruon urundeuva Allemão",
    nomePopular: "Aroeira",
    projeto: "Compensação Ambiental — Corredor Verde Sul",
    municipio: "Goiânia",
    uf: "GO",
    bairro: "Corredor Verde Sul",
    logradouro: "Av. Corredor Verde",
    numero: "s/n",
    coordenada: "-16.7210, -49.2960",
    dap: 6,
    altura: 1.8,
    diametroCopa: 0.8,
    estadoFitossanitario: "bom",
    classeRisco: "baixo",
    recomendacao: "Replantio",
    statusRevisao: "pendente de informação",
    tecnico: "Marcos Vinicius",
    ultimaVistoria: "2026-05-20",
    fotos: 2,
    observacao: "Muda de 6 meses, tutor quebrado. Recomendado replantio para correção de alinhamento e substituição de tutor.",
    fotoUrl: "",
  },
];